<template>
		<nav class="wrappernav">
			<div class="navbar">
				<div class="w-layout-grid navgrid">
					<a :href="/dashboard/"> <img href="/dashboard" src="/img/icons/hyper-logo-white.svg" loading="lazy" alt="Hyper wash Stockholm logo"
						class="image-brand-hyper"></a>
					<nav role="navigation" class="nav">
						<div class="buttons-nav-wrapper">
							<div class="w-layout-grid grid-buttons">
								<div>
									<div @click.prevent="logout" class="button color-red topnav w-button">Logga ut</div>
								</div>
							</div>
						</div>
					</nav>
				</div>
			</div>
		</nav>
</template>
<script>
import {mapActions} from 'vuex';
export default {
	name: 'Header',
	methods: {
        ...mapActions(['logout'])
	}
};
</script>
<style scoped>
.navbar {
	padding-top: 20px;
}
.navgrid{
	padding-right: 0;
	min-height:0;
}
.w-layout-grid{
	grid-row-gap: 0;
}
.buttons-nav-wrapper{
	padding-right: 0px;
}
@media screen and (max-width: 479px) {
	.navbar {
		padding-top: 0px;
	}
	.buttons-nav-wrapper {
		padding: 10px 30px 10px;
	}
	.button.topnav{
		font-size: 14px;
		padding: 10px 20px;
	}
}
@media screen and (max-width: 991px){
	.navbar {
		padding-top: 0px;
	}
	.buttons-nav-wrapper {
		padding: 10px 14px 10px;
	}
	.grid-buttons{
		padding-right: 0;
	}
}
@media screen and (max-width: 767px){
	.buttons-nav-wrapper {
		padding: 10px 30px 10px;
	}
	.image-brand-hyper{
		padding-left:14px;
	}
}
.nav {
	-ms-grid-column-span: 2;
	grid-column-end: 4;
	-ms-grid-column: 2;
	grid-column-start: 2;
	-ms-grid-row-span: 1;
	grid-row-end: 2;
	-ms-grid-row: 1;
	grid-row-start: 1;
	-ms-grid-column-align: end;
	justify-self: end;
	-ms-grid-row-align: center;
	align-self: center;
}
</style>
